<div class="row page-title">
  <span>{{ localizationConstants.FIELD_SERVICE_DETAILS_PAGE_TITLE | translate }}</span>
</div>
<div
  id="main-info"
  class="c-hero bg-white u-shadow">
  <div class="row">
    <div
      *ngIf="fsJob"
      class="c-details col">
      <div class="c-details__title">{{ fsJob.fsNumber }}</div>
      <table class="o-list-table o-list-table--thin o-list-table--even full-width--mobile">
        <tr class="o-list-table__item">
          <td
            scope="row"
            class="o-list-table__title">
            {{ "fieldservice.date" | translate }}
          </td>
          <td class="o-list-table__description">{{ fsJob.date | date }}</td>
        </tr>
        <tr class="o-list-table__item">
          <td
            class="o-list-table__title"
            scope="row">
            {{ "fieldservice.reason" | translate }}
          </td>
          <td class="o-list-table__description">
            {{ fsJob.reason | titlecase }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div
  *ngIf="fsJob"
  id="tabs"
  class="tabs row center u-scroll--horizontal">
  <div class="container col-12 col-lg-8">
    <ul class="c-tab__group">
      <li
        id="tab-details"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.FIELD_SERVICE_CHILD_INFO]"
        [routerLinkActive]="['active']">
        {{ "fieldservice.infotab" | translate }}
      </li>
      <li
        id="tab-tools"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.FIELD_SERVICE_CHILD_TOOLS]"
        [routerLinkActive]="['active']">
        {{ "fieldservice.toolstab" | translate }}
      </li>
      <li
        id="tab-history"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.FIELD_SERVICE_CHILD_HISTORY]"
        [routerLinkActive]="['active']">
        {{ "fieldservice.historytab" | translate }}
      </li>
    </ul>
  </div>
</div>
<div
  *ngIf="fsJob"
  id="details"
  class="row u-mb-2">
  <div class="col-12">
    <router-outlet></router-outlet>
  </div>
</div>
